import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestingPageComponent } from './testing-page.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputModule } from "src/app/shared/components/custom-input/custom-input.module";
import { TestingPageRoutingModule } from './testing-page-routing.module';

@NgModule({
  declarations: [TestingPageComponent],
  imports: [CommonModule, FormsModule, MaterialModule, CustomInputModule,ReactiveFormsModule,TestingPageRoutingModule],
  exports: [TestingPageComponent],
})
export class TestingPageModule {}
